import './qrIndex.css';
import React, { useState } from 'react';
import Layout from '../../components/Layout';
import ManageQR from './manageBulkcard';
import BulkCard from './manageBulkcard';

const BulkCardMain = () => {
  const [showManageQR, setShowManageQR] = useState(true);

  return (
    <Layout>
      {showManageQR ? 
        <ManageQR setShowManageQR={setShowManageQR}/> :
        <BulkCard />
      }
    </Layout>
  );
}

export default BulkCardMain;
